const organizations = {
    title: 'Organizações',
    description: 'Crie e gira as organizações a que pertence.',
    create: 'Criar organização',
    create_title: 'Criar uma nova organização',
    name: 'Nome da organização',
    avatar: 'Avatar da organização',
    avatar_removed: 'Avatar da organização removido.',
    description_label: 'Descrição',
    empty: 'Ainda não pertence a uma organização.',
    pending_invitations: 'Convites pendentes',
    accept: 'Aceitar',
    decline: 'Recusar',
    owner: 'Proprietário',
    tabs: {
        overview: 'Visão geral',
        members: 'Membros',
        invitations: 'Convites',
        roles: 'Funções de gestão',
        branding: 'Identidade visual',
        security: 'Segurança',
        jit: 'Aprovisionamento JIT',
        applications: 'Recursos partilhados',
        activity: 'Atividade',
        deletion: 'Eliminar',
    },
    members: {
        title: 'Membros',
        empty: 'Nenhum membro encontrado.',
        remove: 'Remover',
        removed: 'Membro removido.',
        business_roles: 'Funções de negócio',
        no_business_roles: 'Não existem funções de negócio disponíveis. Peça ao administrador do tenant para partilhar funções com esta organização.',
    },
    invitations: {
        title: 'Convites',
        invite: 'Convidar membro',
        email: 'Endereço de e-mail',
        empty: 'Nenhum convite encontrado.',
        resend: 'Reenviar',
        resent: 'Convite reenviado.',
        revoke: 'Revogar',
        revoked: 'Convite revogado.',
        status: {
            Pending: 'Pendente',
            Accepted: 'Aceite',
            Expired: 'Expirado',
            Revoked: 'Revogado',
            Declined: 'Recusado',
        },
    },
    roles: {
        title: 'Funções de gestão',
        create: 'Criar função',
        permissions: 'Permissões',
        empty: 'Nenhuma função de gestão encontrada.',
        select_member: 'Selecionar membro',
        select_role: 'Selecionar função',
        assign: 'Atribuir função',
        assigned: 'Função atribuída.',
        unassign: 'Remover função',
        unassigned: 'Função removida.',
        permission_count: 'Permissões: {{count}}',
        built_in: {
            owner: 'Proprietário',
            owner_description: 'Os proprietários têm controlo exclusivo sobre a propriedade e a eliminação da organização.',
            administrator: 'Administrador',
            administrator_description: 'Gere a organização, exceto as ações reservadas aos proprietários.',
        },
        permission_labels: {
            update_profile: 'Atualizar perfil',
            manage_branding: 'Gerir identidade visual',
            view_members: 'Ver membros',
            manage_members: 'Gerir membros',
            manage_invitations: 'Gerir convites',
            assign_business_roles: 'Atribuir funções de negócio',
            manage_management_roles: 'Gerir funções de gestão',
            assign_management_roles: 'Atribuir funções de gestão',
            manage_security: 'Gerir segurança',
            manage_jit: 'Gerir aprovisionamento JIT',
            manage_applications: 'Gerir aplicações',
            view_activity: 'Ver atividade',
        },
    },
    branding: {
        title: 'Identidade visual da organização',
        primary_color: 'Cor principal',
        custom_css: 'CSS personalizado',
        preview: 'Pré-visualização',
        light: 'Claro',
        dark: 'Escuro',
    },
    security: {
        title: 'Segurança da organização',
        require_mfa: 'Exigir autenticação multifator aos membros',
    },
    jit: {
        title: 'Domínios de e-mail JIT',
        domain: 'Domínio de e-mail',
        add: 'Adicionar domínio',
        verify: 'Verificar DNS',
        dns_instruction: 'Crie o registo TXT {{record}} com o valor {{value}}.',
        verified: 'Verificado',
    },
    applications: {
        title: 'Recursos partilhados',
        empty: 'Não existem recursos disponíveis para esta organização.',
        sso: 'Ligações SSO empresariais',
        m2m: 'Aplicações máquina a máquina',
    },
    activity: {
        title: 'Atividade da organização',
        empty: 'Ainda não existe atividade.',
        events: {
            create: 'Organização criada',
            delete: 'Organização eliminada',
            profile: 'Perfil da organização atualizado',
            branding: 'Identidade visual atualizada',
            security: 'Segurança da organização atualizada',
            member_add: 'Membro adicionado',
            member_remove: 'Membro removido',
            owner: 'Propriedade da organização atualizada',
            role_create: 'Função de gestão criada',
            role_update: 'Função de gestão atualizada',
            role_delete: 'Função de gestão eliminada',
            role_assign: 'Função de gestão atribuída',
            role_unassign: 'Função de gestão removida do membro',
            business_role: 'Funções de negócio atualizadas',
            invitation_create: 'Convite enviado',
            invitation_accept: 'Convite aceite',
            invitation_decline: 'Convite recusado',
            invitation_revoke: 'Convite revogado',
            jit: 'Aprovisionamento JIT atualizado',
            domain: 'Verificação do domínio de e-mail',
            application: 'Ligações de aplicações atualizadas',
            unknown: 'Atividade da organização',
        },
    },
    save: 'Guardar alterações',
    cancel: 'Cancelar',
    delete: 'Eliminar organização',
    delete_confirmation: 'Esta ação elimina permanentemente a organização e as suas associações de membros. Introduza «{{name}}» para confirmar.',
    deleted: 'Organização eliminada.',
    load_failed: 'Não foi possível carregar os dados da organização. Tente novamente.',
    permission_denied: 'Não tem permissão para ver esta secção.',
};
export default organizations;
